var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h5-page" }, [
    _c("div", { staticClass: "h5-header" }, [_vm._v("配送任务")]),
    _c(
      "div",
      { staticClass: "h5-body" },
      [
        _vm.task && _vm.task.id
          ? _c("div", { staticClass: "h5-card" }, [
              _c("div", { staticClass: "row" }, [
                _c("span", { staticClass: "label" }, [_vm._v("任务号")]),
                _c("span", [_vm._v(_vm._s(_vm.task.taskNo))]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("span", { staticClass: "label" }, [_vm._v("配送员")]),
                _c("span", [_vm._v(_vm._s(_vm.task.courierName))]),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("span", { staticClass: "label" }, [_vm._v("路线方案")]),
                _c("span", [_vm._v(_vm._s(_vm.task.routeModeName))]),
              ]),
              _vm.task.routeSummary
                ? _c("div", { staticClass: "row" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("方案摘要")]),
                    _c("span", [_vm._v(_vm._s(_vm.task.routeSummary))]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "row" }, [
                _c("span", { staticClass: "label" }, [_vm._v("签收进度")]),
                _c("span", { class: _vm.task.status === "2" ? "done" : "" }, [
                  _vm._v(
                    _vm._s(_vm.task.signedCount) +
                      "/" +
                      _vm._s(_vm.task.stopCount) +
                      "（" +
                      _vm._s(_vm.task.statusName) +
                      "）"
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm.task && _vm.task.status === "2"
          ? _c(
              "div",
              { staticClass: "h5-card finish-card" },
              [
                _c("a-icon", {
                  attrs: {
                    type: "check-circle",
                    theme: "twoTone",
                    twoToneColor: "#52c41a",
                  },
                }),
                _c("span", [_vm._v("全部配送点已签收，任务完成")]),
              ],
              1
            )
          : _vm._e(),
        _vm._l(_vm.stops, function (stop) {
          return _c(
            "div",
            {
              key: stop.id,
              staticClass: "h5-card stop-card",
              class: { signed: stop.signed },
            },
            [
              _c(
                "div",
                { staticClass: "stop-head" },
                [
                  _c("span", { staticClass: "stop-seq" }, [
                    _vm._v(_vm._s(stop.seq)),
                  ]),
                  _c("span", { staticClass: "stop-customer" }, [
                    _vm._v(_vm._s(stop.customerName || "客户")),
                  ]),
                  stop.signed
                    ? _c("a-tag", { attrs: { color: "green" } }, [
                        _vm._v("已签收"),
                      ])
                    : _c("a-tag", { attrs: { color: "orange" } }, [
                        _vm._v("待送达"),
                      ]),
                ],
                1
              ),
              _c("div", { staticClass: "stop-line" }, [
                _vm._v("出库单：" + _vm._s(stop.xsckNo)),
              ]),
              _c("div", { staticClass: "stop-line addr" }, [
                _vm._v("地址：" + _vm._s(stop.address || "-")),
              ]),
              stop.signedTime
                ? _c("div", { staticClass: "stop-line" }, [
                    _vm._v("签收时间：" + _vm._s(stop.signedTime)),
                  ])
                : _vm._e(),
              !stop.signed && _vm.task.status !== "2"
                ? [
                    _c(
                      "div",
                      { staticClass: "sign-area" },
                      [
                        _c("a-input", {
                          staticClass: "sign-input",
                          attrs: {
                            placeholder: "出库单号校验（可选）",
                            size: "small",
                          },
                          model: {
                            value: stop.xsckInput,
                            callback: function ($$v) {
                              _vm.$set(stop, "xsckInput", $$v)
                            },
                            expression: "stop.xsckInput",
                          },
                        }),
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              loading: stop.signing,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleSign(stop)
                              },
                            },
                          },
                          [_vm._v("签收送达")]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "sign-tip" }, [
                      _vm._v("可不填出库单号直接签收；填写则校验一致后签收"),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        }),
        !_vm.loading && !_vm.task
          ? _c("div", { staticClass: "empty" }, [
              _vm._v(_vm._s(_vm.errorMsg || "任务不存在或链接已失效")),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }